export enum Departments {
    commercie = 'Commercie',
    designTech = 'Design & Tech',
    directie = 'Directie',
    finance = 'Finance',
    operations = 'Operations',
}
